import { render, staticRenderFns } from "./dialogAssocitionList.vue?vue&type=template&id=5d8c9f5a&"
import script from "./dialogAssocitionList.vue?vue&type=script&lang=js&"
export * from "./dialogAssocitionList.vue?vue&type=script&lang=js&"
import style0 from "./dialogAssocitionList.vue?vue&type=style&index=0&id=5d8c9f5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports